import { render, staticRenderFns } from "./Wm1.vue?vue&type=template&id=2fe51146&scoped=true"
import script from "./Wm1.vue?vue&type=script&lang=js"
export * from "./Wm1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe51146",
  null
  
)

export default component.exports